import { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const navLinks = [
  { path: "/about-us", label: "About Us" },
  { path: "/our-services", label: "Our Services" },
  { path: "/our-product", label: "Our Product" },
  { path: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <>
      <header className="sticky top-0 z-50 bg-white border-b border-background-200 shadow-sm transition-all duration-300">
        <div className="w-full px-4 md:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <Link to="/" className="flex items-center">
              <h1 className="text-2xl font-bold text-primary-600 font-heading">
                Web 3.0 Soft Limited
              </h1>
            </Link>

            <nav className="hidden md:flex items-center space-x-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className={`text-sm font-medium transition-colors whitespace-nowrap ${
                    isActive(link.path)
                      ? "text-primary-600 font-semibold"
                      : "text-foreground-700 hover:text-primary-600"
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </nav>

            <button
              className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700"
              onClick={() => setMobileOpen(true)}
              aria-label="Open menu"
            >
              <i className="ri-menu-line text-2xl"></i>
            </button>
          </div>
        </div>
      </header>

      {/* Mobile menu overlay */}
      <div
        className={`fixed inset-0 bg-black/40 z-40 transition-opacity duration-300 md:hidden ${
          mobileOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
        onClick={() => setMobileOpen(false)}
      />

      {/* Mobile menu panel */}
      <div
        className={`fixed top-0 right-0 bottom-0 w-[280px] bg-white z-50 shadow-xl transform transition-transform duration-300 md:hidden flex flex-col pt-20 px-6 ${
          mobileOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <button
          className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center text-foreground-700"
          onClick={() => setMobileOpen(false)}
          aria-label="Close menu"
        >
          <i className="ri-close-line text-2xl"></i>
        </button>

        <div className="flex flex-col space-y-6">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-lg font-medium transition-colors ${
                isActive(link.path)
                  ? "text-primary-600 font-semibold"
                  : "text-foreground-800 hover:text-primary-600"
              }`}
              onClick={() => setMobileOpen(false)}
            >
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}